module.exports = __webpack_public_path__ + "static/img/nongchang.63523176.png";